// Helpers for the in-WebView "go to another workspace" field on the auth
// screens (see components/Auth/WorkspaceSubdomainField). Pure so they can be
// unit-tested the way src/utils/workspaceHost.ts is - the repo has no
// component-rendering tests.

export function normalizeSubdomainInput(raw: string): string {
  return raw.trim().toLowerCase()
}

const SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/

export function isValidSubdomain(value: string): boolean {
  if (value === "www") return false
  return SUBDOMAIN_RE.test(value)
}

export function buildWorkspaceAuthUrl(args: {
  subdomain: string
  rootDomain: string
  pathname: string
  search: string
}): string {
  const { subdomain, rootDomain, pathname, search } = args
  return `https://${subdomain}.${rootDomain}${pathname}${search}`
}
